import * as React from 'react';
const RightArrow = ({ className, fill = '#1C1B1F' }: { className?: string; fill?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" className={className}>
    <g mask="url(#a)">
      <path fill={fill} d="M12.6 12 8 7.4 9.4 6l6 6-6 6L8 16.6l4.6-4.6Z" />
    </g>
  </svg>
);
export default RightArrow;
